import { camelCase, isArray, transform, isObject } from 'lodash';

const camelize = (obj: Record<string, unknown>) =>
    transform(obj, (result: Record<string, unknown>, value: unknown, key: string, target: unknown | string) => {
        const camelKey = isArray(target) ? key : camelCase(key);
        result[camelKey] = isObject(value) ? camelize(value as Record<string, unknown>) : value;
    });

export default camelize;
